import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=71016a78&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71016a78')) {
      api.createRecord('71016a78', component.options)
    } else {
      api.reload('71016a78', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=71016a78&", function () {
      api.rerender('71016a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zbk7CPKHE1II/JS/ImageCarousel.vue"
export default component.exports